<p-toast position="top-right" key="msj"></p-toast>
<p-confirmDialog [style]="{width: '50vw'}" key="kc" [baseZIndex]="10000" acceptLabel="SI" rejectLabel="NO"
  rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<p-confirmDialog [style]="{width: '50vw'}" key="sinInformacionDialog" [baseZIndex]="10000" acceptLabel="Aceptar"
  rejectLabel="Cancelar" rejectButtonStyleClass="p-button-text" styleClass="color-confirmar" [rejectVisible]="false">
</p-confirmDialog>
<div class="container-fluid" style="border-color: blue; border: 5px ; width: 100%;">
  <div class="row">
    <div class="col-md-12">
      <div class="card card-shadow sinborde">
        <div class="card-header sinborde" style="background: none; ">

          <div class="mb-4">
            <h4>{{ heading }}</h4>
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li *ngFor="let link of links; let last = last" class="breadcrumb-item" [ngClass]="{ active: last }"
                  [attr.aria-current]="last ? 'page' : null">
                  <a *ngIf="!last" [routerLink]="link.href">{{ link.name }}</a>
                  <span *ngIf="last">{{ link.name }}</span>
                </li>
              </ol>
            </nav>
          </div>



        </div>


          <p-table #dt1 [value]="lstgestionkilometraje" [scrollable]="true" scrollHeight="flex" scrollDirection="both"
            [paginator]="true" [rows]="50" [rowsPerPageOptions]="[100,150,200,300,500]" [showCurrentPageReport]="true"
            currentPageReportTemplate=" {first} a {last} de {totalRecords} Registros"
            [globalFilterFields]="['num_economico','desc_placaUnidad', 'vin']" [loading]="loading">
            <ng-template pTemplate="caption">

              <div class="row d-flex justify-content-center ">
                <!-- <div class="col-12 sm:col-6 xl:col-2">
                  <div class="card-custom ">
                    <span>Total de unidade capturadas hoy: <label style="color: green;"><b> 80</b></label></span>
                  </div>

                </div> -->
                <div class="col-12 md:col-3 lg:col-3 xl:col-3  d-flex justify-content-center ignorar-wrapper">

                  <button pButton pRipple type="button" [disabled]="loading_reporte" (click)="openDialogReporte();"
              label="Reportes" icon="pi pi-arrow-up-right" iconPos="left" class="custom-openExcel"  ></button>
                </div>


                <div class="col-12 md:col-3  lg:col-3 xl:col-3  mt-1 ignorar-wrapper">
                  <p-columnFilter field="clv_estatus" matchMode="equals" [showMenu]="false">
                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                      <p-dropdown [ngModel]="value" [options]="lstEstatus" optionLabel="desc_estatus"
                        optionValue="clv_estatus" (onChange)="filter($event.value)" placeholder="Filtrar Estatus"
                        [showClear]="true">
                      </p-dropdown>
                    </ng-template>
                  </p-columnFilter>
                </div>


                <div class="col-12 md:col-3  lg:col-3 xl:col-3  mt-1 ignorar-wrapper">
                  <p-columnFilter field="id_ciudad" matchMode="equals" [showMenu]="false">
                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                      <p-dropdown [ngModel]="value" [options]="lstCiudades" optionLabel="nombre" optionValue="id"
                        (onChange)="filter($event.value)" placeholder="Filtrar ciudad" [showClear]="true">
                      </p-dropdown>
                    </ng-template>
                  </p-columnFilter>
                </div>
                <div class="col-12 md:col-3 lg:col-3 xl:col-3 ignorar-wrapper ">
                  <span class="p-input-icon-left">
                    <i class="pi pi-search" style="margin-right: 5px;"></i>
                    <input pInputText pTooltip="Buscar placa, numero economico o VIN" type="text"
                      (input)="applyFilterGlobal($event, 'contains')" placeholder="Buscar #Eco, Placa,Serie"
                      style=" min-width: 100%;" />
                  </span>
                </div>

              </div>
            </ng-template>
         <ng-template pTemplate="header">
  <tr>
    <th class="resp-th text-center">#</th>
    <th class="resp-th">#Económico</th>
    <th class="resp-th">Descripción</th>
    <th class="resp-th text-center">Tipo</th>
    <th class="resp-th text-center">Ciudad</th>
    <th class="resp-th text-center">Estatus</th>
    <th class="resp-th text-center">Operaciones</th>
  </tr>
</ng-template>

<ng-template pTemplate="body" let-data let-rowIndex="rowIndex">
  <tr [ngClass]="{'row-baja': data.clv_estatus !==1}">
    <td class="resp-td text-center">{{ (rowIndex+1) }}</td>
    <td class="resp-td text-center" style="color: #8bb174; font-weight: bold;">{{data.num_economico}}</td>
    <td class="resp-td"><b>{{ data.marca }}->{{ data.modelo }}->{{ data.color }}</b></td>
    <td class="resp-td text-center">{{data.configuracionunidad}}</td>
    <td class="resp-td text-center">{{data.desc_ciudad}}</td>
    <td class="resp-td text-center" style="min-width: 150px; max-width: 150px;">
      <div class="d-flex justify-content-around">
        <p-tag class="tag-sm custom-tag activa" *ngIf="data.clv_estatus == 1" value="ACTIVA"></p-tag>
        <p-tag class="tag-sm custom-tag inactiva" *ngIf="data.clv_estatus == 0" value="INACTIVA"></p-tag>
        <p-tag class="tag-sm custom-tag baja" *ngIf="data.clv_estatus == 3" value="BAJA DE OPERACION"></p-tag>
      </div>
    </td>
    <td class="resp-td text-center">
      <div class="gap-3 d-flex justify-content-center">
        <button pButton pRipple class="custom-agregar" icon="pi pi-plus" (click)="agregarNuevo(data);" pTooltip="Agregar registro"></button>
        <button pButton pRipple class="custom-his" icon="pi pi-book" (click)="dspOpenHistorico(data);" pTooltip="Historico"></button>
      </div>
    </td>
  </tr>
</ng-template>

          </p-table>

      </div>
    </div>


  </div>


  <!-- Dialog de agregar -->
  <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspAgregar" styleClass="card-shadow responsive-dialog"
    [transitionOptions]="'0ms'" (onHide)="cancelarModal()">

    <ng-template pTemplate="header">
      <div class="d-flex justify-content-start">
        <div class="col-md-12">Agregar</div>
      </div>
    </ng-template>

      <ng-template pTemplate="content">
            <form [formGroup]="reactiveform">
        <div class="mt-1">
          <div class="row mb-3">
            <span class="title-light">
              Proporcione la información solicitada
              <i class="pi pi-cog" style="font-size: 1rem;"></i>
            </span>
          </div>

          <!-- Input nombre -->
          <div class="p-float-label mt-4">
            <input [disabled]="true" id="nombre" type="text" pInputText formControlName="num_economico"
              class="form-control fw-bold" [style]="{ minWidth: '100%', width: '100%' }" />
            <label for="nombre" style="font-weight: bold;">Numero economico</label>
          </div>

          <div class="mt-2 ">
            <label for="nombre" style="font-size: 12px; color: grey;" class="fw-bold mb-1 d-block ml-2">Seleccione
              Estatus
              de Ruta</label>
            <p-dropdown inputId="nombre" [options]="lstruta" optionLabel="Ruta" optionValue="id_ruta"
              formControlName="id_estatus_unidad" [style]="{ minWidth: '100%', width: '100%' }"
              placeholder="Seleccione Estatus de Ruta"></p-dropdown>
          </div>



          <!-- Fecha del día -->
          <div class="p-float-label mt-5">
            <input type="date" id="fecha-dia" formControlName="fec_gestionKilometraje" class="p-inputtext"
              style="width: 100%;" [ngClass]="{ 'p-filled': this.reactiveform.get('fec_gestionKilometraje')?.value }" />
            <label for="fecha-dia" style="font-weight: bold;">Fecha del día</label>
          </div>

        </div>
        <div class="row  mt-5 ">
          <div class="col-md-6">
            <div class="p-float-label">
              <input [disabled]="true" id="nombre" type="number" pInputText formControlName="kilometraje_anterior"
                [style]="{ minWidth: '100%', width: '100%' }" class="form-control fw-bold" />
              <label for="nombre" style="font-weight: bold;">Ultimo Kilometraje</label>
            </div>
          </div>
          <div class="col-md-6 mb-4">
            <div class="p-float-label">
              <input id="nombre" type="number" pInputText formControlName="kilometraje_nuevo"
                [style]="{ minWidth: '100%', width: '100%' }" />
              <label for="nombre" style="font-weight: bold;">Kilometraje</label>
            </div>
          </div>
        </div>

 </form>
      </ng-template>


    <ng-template pTemplate="footer">
      <button pButton pRipple label="Cancelar" icon="pi pi-times" class="custom-cancelar" (click)="cancelarModal();">
      </button>
      <button pButton pRipple label="Guardar" [disabled]="!reactiveform.valid" icon="pi pi-save" class="custom-editar" (click)="guardar(1);">
      </button>
    </ng-template>

  </p-dialog>


  <!-- dialog para editar -->
  <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspEditar" styleClass="card-shadow responsive-dialog"
    [transitionOptions]="'0ms'" (onHide)="cancelarModalEditar()">

    <ng-template pTemplate="header">
      <div class="d-flex justify-content-start">
        <div class="col-md-12">Editar</div>
      </div>
    </ng-template>

      <ng-template pTemplate="content">
           <form [formGroup]="reactiveform">
        <div class="mt-1">
          <div class="row mb-3">
            <span class="title-light">
              Proporcione la información solicitada
              <i class="pi pi-cog" style="font-size: 1rem;"></i>
            </span>
          </div>

          <!-- Input nombre -->
          <div class="p-float-label mt-4">
            <input [disabled]="true" id="nombre" type="text" pInputText formControlName="num_economico"
              class="form-control fw-bold" [style]="{ minWidth: '100%', width: '100%' }" />
            <label for="nombre" style="font-weight: bold;">Numero economico</label>
          </div>

          <div class="mt-2 ">
            <label for="nombre" style="font-size: 12px; color: grey;" class="fw-bold mb-1 d-block ml-2">Seleccione
              Estatus
              de Ruta</label>
            <p-dropdown inputId="nombre" [options]="lstruta" optionLabel="Ruta" optionValue="id_ruta"
              formControlName="id_estatus_unidad" [style]="{ minWidth: '100%', width: '100%' }"
              placeholder="Seleccione Estatus de Ruta"></p-dropdown>
          </div>



          <!-- Fecha del día -->
          <div class="p-float-label mt-5">
            <input type="date" id="fecha-dia" formControlName="fec_gestionKilometraje" class="p-inputtext"
              style="width: 100%;" [ngClass]="{ 'p-filled': reactiveform.get('fec_gestionKilometraje')?.value }" />
            <label for="fecha-dia" style="font-weight: bold;">Fecha del día</label>
          </div>

        </div>
        <div class="row  mt-5 ">
          <div class="col-md-6">
            <div class="p-float-label">
              <input id="nombre" type="number" pInputText formControlName="kilometraje_anterior"
                [style]="{ minWidth: '100%', width: '100%' }" class="form-control fw-bold" />
              <label for="nombre" style="font-weight: bold;">Ultimo Kilometraje</label>
            </div>
          </div>
          <div class="col-md-6 mb-4">
            <div class="p-float-label">
              <input id="nombre" type="number" pInputText formControlName="kilometraje_nuevo"
                [style]="{ minWidth: '100%', width: '100%' }" />
              <label for="nombre" style="font-weight: bold;">Kilometraje</label>
            </div>
          </div>
        </div>

       </form>
      </ng-template>

    <ng-template pTemplate="footer">
      <button pButton pRipple label="Cancelar" icon="pi pi-times" class="custom-cancelar"
        (click)="cancelarModalEditar();">
      </button>
      <button pButton pRipple label="Guardar" icon="pi pi-save" class="custom-editar" [disabled]="!reactiveform.valid " (click)="guardar(2);">
      </button>
    </ng-template>

  </p-dialog>



  <!-- dialog de historico------------------------- -->
  <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspOpenHis"
    styleClass="card-shadow responsive-dialog tabla-historica-dialog" [transitionOptions]="'0ms'"
    (onHide)="cancelarModalHis()">
    <!-- Header -->
    <ng-template pTemplate="header">
      <div class="d-flex justify-content-start">
        <div class="col-12">Historial de Unidades</div>
      </div>
    </ng-template>

    <!-- Contenido -->

    <ng-template pTemplate="content">
      <div class="mt-1 row mb-3">
        <span class="title-light">
          Seleccione la información solicitada
          <i class="pi pi-cog" style="font-size: 1rem;"></i>
        </span>
      </div>
      <div class="row mt-5 ml-5 d-flex justify-content-center align-items-center">
        <div class="row  ">

          <div class="col-12 sm:col-6 md:col-3 lg:col-3 xl:col-3">
            <div class="p-float-label">
              <input type="date" id="fecha-inicio" (ngModelChange)="limpiarlist()" [(ngModel)]="fec_inicio"
                class="p-inputtext" style="width: 100%;" [ngClass]="{ 'p-filled': fec_inicio }" />
              <label for="fecha-inicio" style="font-weight: bold;">Fecha Inicio</label>
            </div>
          </div>

          <div class="col-12 sm:col-6 md:col-3 lg:col-3 xl:col-3">
            <div class="p-float-label">
              <input type="date" id="fecha-fin" (ngModelChange)="limpiarlist()" [(ngModel)]="fec_fin"
                class="p-inputtext" style="width: 100%;" [ngClass]="{ 'p-filled': fec_fin }" />
              <label for="fecha-fin" style="font-weight: bold;">Fecha Fin</label>
            </div>
          </div>


          <div class="col-12 sm:col-3 md:col-3 lg:col-3 xl:col-2" style="align-content: flex-end;">
            <button pButton pRipple type="button" [disabled]="loading_reporte" (click)="getHistorico();" label="Filtrar"
              icon="pi pi-filter" iconPos="left" class="custom-editar "></button>
          </div>

          <!-- <div class="col-12 sm:col-3 md:col-3 lg:col-3 xl:col-32" style="align-content: flex-end;">
            <button pButton pRipple class="custom-agregar" icon="pi pi-plus" (click)="agregarNuevo(data);"
              pTooltip="Agregar registro"></button>
          </div> -->


          <div class="col-12 sm:col-3 md:col-3 lg:col-3 xl:col-3 " style="align-content: flex-end;">
            <button pButton pRipple type="button" [disabled]="loading_reporte" (click)="getRptGestionKilometraje();"
              label="Exportar" icon="pi pi-file-export" iconPos="left" class="custom-his"></button>
          </div>


        </div>
      </div>

      <div class="tabla-responsiva-wrapper">
        <p-table #dt1 [value]="lstHistorico" [scrollable]="true" scrollHeight="flex" scrollDirection="both"
          [paginator]="true" [rows]="10" [rowsPerPageOptions]="[20,30,50,100,150, 200]" [showCurrentPageReport]="true"
          currentPageReportTemplate="{first} a {last} de {totalRecords} Registros"
          [globalFilterFields]="['num_economico', 'nombre_chofer', 'num_folio', 'desc_tipo_aprovechamiento']"
          [loading]="loading_reporte">


          <ng-template pTemplate="header">
            <tr>
              <th class="text-center">#</th>
              <th>#Económico</th>
              <th>Ruta</th>
              <th class="text-center">Fecha</th>
              <th class="text-center">Kilometraje anterio</th>
              <th class="text-center">Kilometraje</th>
              <th class="text-center">Edicion</th>
            </tr>
          </ng-template>

          <!-- Cuerpo -->
          <ng-template pTemplate="body" let-data let-rowIndex="rowIndex">
            <tr>
              <td class="text-center">{{ rowIndex + 1 }}</td>
              <td class="text-center" style="color: #8bb174; font-weight: bold;">
                {{ data.num_economico }}
              </td>
              <td>{{data.desc_estatus_unidad}}</td>
              <td class="text-center">{{data.fec_gestionKilometraje}}</td>
              <td class="text-center">{{ data.kilometraje_anterior }}</td>
              <td class="text-center">{{ data.kilometraje_nuevo }}</td>

              <td>
                <div class="gap-3 d-flex justify-content-center ">

                  <button pButton pRipple class="custom-editar"
                  [disabled]="data.fec_gestionKilometraje !== this.fec_hoy && this.clv_operacion !==3 && this.clv_operacion !==1"
                  icon="pi pi-pencil" (click)="openModalEditar(data);"
                    pTooltip="Editar"></button>
                </div>
              </td>
            </tr>
          </ng-template>


        </p-table>
      </div>
    </ng-template>


    <!-- Footer -->
    <ng-template pTemplate="footer">
      <button pButton pRipple label="Cerrar" icon="pi pi pi-times" class="custom-cancelar"
        (click)="cancelarModalHis()"></button>
    </ng-template>
  </p-dialog>




     <!-- dialog de historico------------------------- -->
         <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspReportes"
    styleClass="card-shadow responsive-dialogReportes " [transitionOptions]="'0ms'"
      (onHide)="closeDialogReporte()">

    <!-- Header -->
    <ng-template pTemplate="header">
      <div class="d-flex justify-content-start">
        <div class="col-12">Reportes</div>
      </div>
    </ng-template>

    <!-- Contenido -->

    <ng-template pTemplate="content">
      <div class="mt-1 row mb-3">
        <span class="title-light">
          Ingrese la información del reporte a emitir
          <i class="pi pi-cog" style="font-size: 1rem;"></i>
        </span>
      </div>
      <div class="row mt-5 ml-5 d-flex justify-content-center align-items-center">
        <div class="row  ">
            <div class="col-12  lg:col-3 xl:col-3">
        <span class="title-light">
          Gestión de Kilometraje Al dia
          <!-- <i class="pi pi-cog" style="font-size: 1rem;"></i> -->
        </span>
      </div>

          <div class="col-12  lg:col-3 xl:col-3">
            <div class="p-float-label">
              <input type="date" id="fecha-inicio" (ngModelChange)="limpiarlist()" [(ngModel)]="fec_inicioRpt"
                class="p-inputtext" style="width: 100%;" [ngClass]="{ 'p-filled': fec_inicioRpt }" />
              <label for="fecha-inicio" style="font-weight: bold;">Fecha Inicio</label>
            </div>
          </div>

          <div class="col-12  lg:col-3 xl:col-3">
            <div class="p-float-label">
              <input type="date" id="fecha-fin" (ngModelChange)="limpiarlist()" [(ngModel)]="fec_finRpt"
                class="p-inputtext" style="width: 100%;" [ngClass]="{ 'p-filled': fec_finRpt }" />
              <label for="fecha-fin" style="font-weight: bold;">Fecha Fin</label>
            </div>
          </div>

<!--
          <div class="col-12 sm:col-3 md:col-3 lg:col-3 xl:col-3 " style="align-content: flex-end;">
            <button pButton pRipple type="button" [disabled]="loading_reporte" (click)="getHistorico();" label="Filtrar"
              icon="pi pi-filter" iconPos="left" class="custom-editar "></button>
          </div> -->




          <div class="col-12  lg:col-3 xl:col-3 d-flex justify-content-center" >
            <button pButton pRipple type="button" [disabled]="loading_reporte" (click)="generarReporte();"
              label="Exportar" icon="pi pi-file-export" iconPos="left" class="custom-his"></button>
          </div>


        </div>
      </div>


    </ng-template>


    <!-- Footer -->
    <ng-template pTemplate="footer">
      <button pButton pRipple label="Cerrar" icon="pi pi pi-times" class="custom-cancelar"
        (click)="closeDialogReporte()"></button>
    </ng-template>
  </p-dialog>
